import { createElement } from 'react';
/**
 * Compose multiple context providers together:
 * <Provider1>
 *     <Provider2>            <ComposeProviders providers={[Provider1, Provider2]}>
 *         {children}   =>        {children}
 *     </Provider2>           </ComposeProviders>
 * </Provider1>
 */
export function ComposeProviders({ providers = [], children, }) {
    return providers.reduceRight((composed, Provider) => {
        return createElement(Provider, null, composed);
    }, children);
}
